/* eslint-disable no-promise-executor-return */
import { getAuthSession } from '../../amplify/authUtilities';
import { apiDelete, apiGet, apiPost, apiPut } from '../../amplify/restClient';

async function callApi(method, payload, resource) {
  const session = await getAuthSession();
  const myInit = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: session.tokens?.idToken?.toString(),
    },
  };
  if (payload !== null && payload !== undefined) {
    myInit.body = payload;
  }

  let response;
  try {
    if (method === 'get') {
      response = await apiGet('myAPI', `reports/${resource}`, myInit);
    }
    if (method === 'post') {
      response = await apiPost('myAPI', `reports/${resource}`, myInit);
    }
    if (method === 'put') {
      response = await apiPut('myAPI', `reports/${resource}`, myInit);
    }
    if (method === 'delete') {
      response = await apiDelete('myAPI', `reports/${resource}`, myInit);
    }
  } catch (error) {
    console.log('Error while accessing API', error.response);
    throw new Error(error);
  }

  return response;
}

async function getData() {
  try {
    // returns array of all projects
    const data = await callApi('get', null, '');
    return data;
  } catch (e) {
    console.error('Error while accessing reports > getData API.');
    console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
    throw new Error(e.response.data); // error message from the backend lambda
  }
}

async function postData(payload) {
  try {
    const data = await callApi('post', payload, '');
    return { ...data };
  } catch (e) {
    console.error('Error while accessing reports > postData API.');
    console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
    throw new Error(e.response.data); // error message from the backend lambda
  }
}

async function putData(payload) {
  try {
    const data = await callApi('put', payload, '');
    return { ...data };
  } catch (e) {
    console.error('Error while accessing reports > putData API.');
    console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
    throw new Error(e.response.data); // error message from the backend lambda
  }
}

async function deleteData(payload) {
  try {
    const data = await callApi('delete', payload, '');
    return { ...data };
  } catch (e) {
    console.error('Error while accessing reports > deleteData API.');
    console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
    throw new Error(e.response.data); // error message from the backend lambda
  }
}

export default {
  getData,
  postData,
  putData,
  deleteData,
};
